/**
 * ISI Module
 *
 */
import { MQ } from "../helpers/constants.js";
import { Navigation } from "./Navigation.js";

//------------------------------------------------------------------------------------------------------------------
// ::: CONSTANTS
//------------------------------------------------------------------------------------------------------------------

//------------------------------------------------------------------------------------------------------------------
// ::: PUBLIC VARIABLES
//------------------------------------------------------------------------------------------------------------------

//------------------------------------------------------------------------------------------------------------------
// ::: PRIVATE VARIABLES
//------------------------------------------------------------------------------------------------------------------

//------------------------------------------------------------------------------------------------------------------
// ::: GETTERS & SETTERS
//------------------------------------------------------------------------------------------------------------------

//------------------------------------------------------------------------------------------------------------------
// ::: PUBLIC FUNCTIONS
//------------------------------------------------------------------------------------------------------------------

const ISI = {
    vars: {
        iScrollOptions: {
            disablePointer: true,
            disableTouch: false,
            disableMouse: false,
            mouseWheel: true,
            bounce: false,
            click: true,
            scrollbars: "custom",
            interactiveScrollbars: true,
        },

        isi: null,
        isi2: null,
    },

    createScrollInstance: function (selector) {
        if (!selector || !document.querySelector(selector)) {
            return null;
        }

        return new IScroll(selector, ISI.vars.iScrollOptions);
    },

    refreshScrollInstance: function (instance) {
        if (instance && typeof instance.refresh === "function") {
            instance.refresh();
        }
    },

    refreshScrollInstances: function () {
        ISI.refreshScrollInstance(ISI.vars.isi);

        if (ISI.vars.isi2 !== ISI.vars.isi) {
            ISI.refreshScrollInstance(ISI.vars.isi2);
        }
    },

    updateMobileViewportHeight: function () {
        const viewportHeight = window.visualViewport
            ? window.visualViewport.height
            : window.innerHeight;

        if (!viewportHeight) {
            return "";
        }

        const mobileViewportHeight = `${viewportHeight}px`;

        document.documentElement.style.setProperty(
            "--isi-mobile-viewport-height",
            mobileViewportHeight
        );

        if (window.innerWidth < 1200 && $("#isi").hasClass("expand")) {
            ISI.refreshScrollInstances();
        }

        return mobileViewportHeight;
    },

    syncDesktopScrollLock: function () {
        const shouldLockScroll =
            MQ.LG.matches &&
            ($("#isi").hasClass("expand") ||
                $("#isi .outer").hasClass("expand"));

        $("html, body").toggleClass("noscroll", shouldLockScroll);
    },

    init: function (e) {
        ISI.updateMobileViewportHeight();

        if (window.visualViewport) {
            window.visualViewport.addEventListener(
                "resize",
                ISI.updateMobileViewportHeight
            );
            window.visualViewport.addEventListener(
                "scroll",
                ISI.updateMobileViewportHeight
            );
        } else {
            window.addEventListener(
                "resize",
                ISI.updateMobileViewportHeight
            );
        }

        ISI.syncDesktopScrollLock();

        $(document).ready(function () {
            /* if static-isi is in view hide sticky-isi onLoad*/
            if (ISI.isOnScreen($("#isi-static")) && window.innerWidth < 1200 || ISI.isOnScreen($("footer"))) {
                $("#isi-sm").addClass("reached");
                $("#isi").addClass("reached");
            } else {
                $("#isi-sm").removeClass("reached");
                $("#isi").removeClass("reached");
            }

            /* if static-isi is in view hide sticky-isi while scrolling*/
            /* prevent sticky isi to display if isi-static not in view at the footer*/
            window.addEventListener("scroll", function (e) {
                console.log(ISI.isOnScreen($("#isi-static")));

                if (
                    ISI.isOnScreen($("#isi-static")) &&
                    window.innerWidth < 1200 || ISI.isOnScreen($("footer"))
                ) {
                    /* Pass element id/class you want to check */
                    $("#isi-sm").addClass("reached");
                    $("#isi").addClass("reached");
                } else {
                    $("#isi-sm").removeClass("reached");
                    $("#isi").removeClass("reached");
                }
            });
        });

        // TODO: DOCUMENT THIS
        // FOR DEBUG
        if (ENVIRONMENT === "development") {
            ISI._dbg_removeISIMobile();
            return;
        }

        ISI.bindEvents();

        ISI.vars.isi =
            ISI.createScrollInstance("#isi-sm .outer") ||
            ISI.createScrollInstance("#isi .outer");
        ISI.vars.isi2 =
            ISI.createScrollInstance("#isi-lg .outer") || ISI.vars.isi;

        /*affix*/
        $("#home #isi-lg").affix({ offset: { top: 93 } });

        $(window).on("scroll", function () {
            if (MQ.LG.matches) {
                $(".isi_nav_wrap ").affix("checkPosition");
            }
        });

        /*refresh iscroll on window resize*/
        $(window).on("resize", function () {
            if ($("#isi .outer").hasClass("expand")) {
                ISI.events.adjust();
            } else {
                if (MQ.LG.matches) {
                    ISI.refreshScrollInstance(ISI.vars.isi2);
                } else {
                    ISI.refreshScrollInstance(ISI.vars.isi);

                    if (!ISI.isOnScreen($("#isi-static"))) {
                        $("#isi-sm").removeClass("reached");
                        $("#isi").removeClass("reached");
                    }
                }
            }

            ISI.syncDesktopScrollLock();
        });

        /*sidebar refresh iscroll on scroll*/
        $(window).on("scroll", function () {
            ISI.refreshScrollInstance(ISI.vars.isi2);
        });

        $(document).ready(function () {
            /* if static-isi is in view hide sticky-isi onLoad*/
            if (!ISI.isOnScreen($("#isi-static")) || window.innerWidth < 1200) {
                /* Pass element id/class you want to check */
                $("#isi-sm").removeClass("reached");
                $("#isi").removeClass("reached");
            } else {
                $("#isi-sm").addClass("reached");
                $("#isi").addClass("reached");
            }

            /* if static-isi is in view hide sticky-isi while scrolling*/
            /* prevent sticky isi to display if isi-static not in view at the footer*/
            window.addEventListener("scroll", function (e) {
                if (
                    ISI.isOnScreen($("#isi-static")) &&
                    this.window.innerWidth < 1200 || ISI.isOnScreen($("footer"))
                ) {
                    /* Pass element id/class you want to check */
                    $("#isi-sm").addClass("reached");
                    $("#isi").addClass("reached");
                } else {
                    $("#isi-sm").removeClass("reached");
                    $("#isi").removeClass("reached");
                }
            });
            ISI.refreshScrollInstance(ISI.vars.isi);
        });

        setTimeout(function () {
            //check #isi anchor on page load
            if (window.location.hash === "#isi") {
                ISI.events.isiLink();
            }
        }, 100);
    },

    _dbg_removeISIMobile: function () {
        $("#isi-sm").remove();
    },

    isOnScreen: function (elem) {
        /* detect element if in view of viewport */
        // if the element doesn't exist, abort
        if (elem.length == 0) {
            return;
        }

        const $window = $(window);
        const isiSm = $("#isi").outerHeight();
        const viewport_top = $window.scrollTop();
        const viewport_height = $window.outerHeight() - isiSm;
        const viewport_bottom = viewport_top + viewport_height;

        const $elem = $(elem);
        const top = $elem.offset().top;
        const height = $elem.height();
        const bottom = top + height;

        return (
            (top >= viewport_top && top < viewport_bottom) ||
            (bottom > viewport_top && bottom <= viewport_bottom) ||
            (height > viewport_height &&
                top <= viewport_top &&
                bottom >= viewport_bottom)
        );
    },

    bindEvents: function (e) {
        $("#isi .button").on("click", ISI.events.expand);
        $("#isi .isi-close").on("click", ISI.events.close);

        //isi link at top
        $('.utility_nav a[href="#isi"]').on("click", ISI.events.isiLink);
    },

    events: {
        expand: function () {
            /*expand button for global isi*/
            if ($("#isi .outer").hasClass("expand")) {
                $("#isi").removeClass("expand");
                $("#isi .outer").removeClass("expand").removeClass("off");
                $("#isi-sm .outer").removeClass("expand").css("height", "20vh");
                setTimeout(function () {
                    $("#isi-sm .outer").css("height", "");
                }, 0);
                $(".button").removeClass("minimize");
                $("#isi-sm").removeClass("bring-top");
                $("#isi-lg").removeClass("no-margin");
                $("#isi-lg .outer").css("width", "20vw");
            } else {
                $("#isi").addClass("expand");
                $("#isi .outer").addClass("expand").addClass("off");
                $("#isi-sm .outer")
                    .addClass("expand")
                    .css("height", ISI.updateMobileViewportHeight());
                $("#isi-sm").addClass("bring-top");
                $(".button").addClass("minimize");
                $("#isi-lg").addClass("no-margin");
                $("#isi-lg .outer").css("width", window.innerWidth - 150);
            }

            ISI.syncDesktopScrollLock();
            setTimeout(function () {
                ISI.refreshScrollInstances();
            }, 600);
        },

        adjust: function (e) {
            $("#isi").addClass("expand");
            $("#isi .outer").addClass("expand");
            $("#isi-sm .outer")
                .addClass("expand")
                .css("height", ISI.updateMobileViewportHeight());
            $("#isi-sm").addClass("bring-top");
            $(".button").addClass("minimize");
            $("#isi-lg").addClass("no-margin");
            ISI.syncDesktopScrollLock();
            setTimeout(function () {
                ISI.refreshScrollInstances();
            }, 600);
        },

        /*close button for sidebar isi*/
        close: function (e) {
            $("#isi").removeClass("expand");
            $("#isi .outer").removeClass("expand");
            $("#isi-sm .button").removeClass("minimize");
            $("#isi-lg .button").fadeIn();
            $("#isi-lg .isi-close").fadeOut();
            ISI.syncDesktopScrollLock();
            setTimeout(function () {
                ISI.refreshScrollInstances();
            }, 600);
        },
        isiLink: function (e) {
            if (typeof e !== "undefined") {
                e.preventDefault();
            }

            const mod = 25;
            if (MQ.LG.matches) {
                ISI.events.expand(e);
            } else {
                Navigation.vars.lockMobileMenu = true;
                $("html, body").animate(
                    {
                        scrollTop:
                            $("#isi-static #isi-section").offset().top - mod,
                    },
                    "fast",
                    "swing",
                    function () {
                        setTimeout(function () {
                            $(".nav_wrapper").removeClass("nav_show_down");
                            Navigation.vars.lockMobileMenu = false;
                        }, 50);
                    }
                );
            }
        },
    },
};

//------------------------------------------------------------------------------------------------------------------
// ::: PRIVATE FUNCTIONS
//------------------------------------------------------------------------------------------------------------------

//------------------------------------------------------------------------------------------------------------------
// ::: CALLBACKS & EVENT HANDLERS
//------------------------------------------------------------------------------------------------------------------

//------------------------------------------------------------------------------------------------------------------
// ::: API
//------------------------------------------------------------------------------------------------------------------

export { ISI };
